<template>
  <div class="new-top-up-form">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="用户充值信息" name="first">

        <el-form ref="form" :model="form" :rules="rules" inline label-width="140px">
          <div class="tables">
            <table>
              <tr>
                <td>单号</td>
                <td>
                  <el-form-item prop="fBillNo">
                    <el-input v-model="form.fBillNo" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>制单时间</td>
                <td>
                  <el-form-item prop="fCreateTime">
                    <el-input v-model="form.fCreateTime" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>制单人</td>
                <td>
                  <el-form-item prop="fCreater">
                    <el-input v-model="form.fCreater" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>经销商名称</td>
                <td>
                  <el-form-item prop="fDistributorID">
                    <el-select
                      v-model="form.fDistributorID"
                      placeholder=""
                      size="small"
                      filterable
                      clearable
                      :disabled="form.readOnly"
                      style="width:93%"
                      @change="selectDisChange"
                    >
                      <el-option
                        v-for="item in form.list"
                        :key="item.fid"
                        :label="item.fName"
                        :value="item.fid"
                      />
                    </el-select>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td>转账金额</td>
                <td>
                  <el-form-item prop="fMoney_zz">
                    <el-input-currency v-model="form.fMoney_zz" :scale="2" :disabled="form.readOnly" size="small" :min="null" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>代扣金额（借款）</td>
                <td>
                  <el-form-item prop="fMoney_jk">
                    <el-input-currency v-model="form.fMoney_jk" :scale="2" :disabled="form.readOnly" size="small" :min="null" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>充值账户</td>
                <td>
                  <el-form-item prop="fDistributorNumber">
                    <el-input v-model="form.fDistributorNumber" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>总充值金额</td>
                <td>
                  <el-form-item prop="total">
                    <el-input-currency v-model="form.total" :scale="2" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>付款单位名称</td>
                <td>
                  <el-form-item prop="fPay">
                    <el-input v-model="form.fPay" :disabled="form.readOnly" size="small" />
                  </el-form-item>
                </td>
              </tr>
            </table>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane v-if="form.procedureMessage" label="单据流程" name="second">
        <el-table
          :data="form.procedureMessage"
          class="tb-edit"
          style="width: 100%"
          highlight-current-row
        >
          <el-table-column label="单流程步骤" prop="fName" />
          <el-table-column label="处理人" prop="fUserName" />
          <el-table-column
            label="状态"
            prop="fState"
            width="75"
          />
          <el-table-column
            label="日期"
            prop="fDate"
            :formatter="dateFormat"
          />
          <el-table-column
            label="意见"
            prop="fOpinion"
          />
        </el-table>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      activeName: 'first',
      rules: {
        fDistributorID: [
          { required: true, message: '必填项', trigger: 'change' }
        ],

        fCreateTime: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fCreater: [
          { required: true, message: '必填项', trigger: 'change' }
        ],

        fPay: [
          { required: true, message: '必填项', trigger: 'change' }
        ]
      },
      display: true
    }
  },
  computed: {
  },
  watch: {
    'form.fMoney_jk': function(val, oldVal) {
      // console.log(val, 'val')
      this.form.total = Number(val + this.form.fMoney_zz)
    },
    'form.fMoney_zz': function(val, oldVal) {
      // console.log(val, 'val')
      this.form.total = Number(val + this.form.fMoney_jk)
    }
  },
  mounted: function() {
    // console.log(this.form, 'this.form')
    const date = this.form.fCreateTime
    if (date == undefined || date == 'Invalid date' || date == '') {
      this.form.fCreateTime = ''
    } else {
      this.form.fCreateTime = moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
    if (this.form.fid == null) {
      this.form.fDistributorID = this.form.list[0].fid
      this.selectDisChange(this.form.fDistributorID)
    }
  },
  created() {},
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    },
    selectDisChange(row) {
      // console.log(row, 'w')
      this.form.list.forEach(v => {
        if (row == v.fid) {
          this.form.fDistributorName = v.fName
          this.form.fDistributorNumber = v.fNumber
        }
      })
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    handleClick() {

    }

  }
}
</script>

<style lang="less" >
.new-top-up-form {
  .el-table td,
  .el-table th {
    padding: 5px 0;
  }
  .el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
.el-form-item {
     margin-bottom: 0px;
    .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 23%;
    left: 16px;
}
}
.tables{
table{
  border-collapse:collapse;
   border-bottom:1px solid rgb(158, 158, 158);
      width:100%;
   tr{
      display: flex;

    }
    td{
      border-collapse:collapse;
      flex:3;
      border:1px solid rgb(158, 158, 158);
      border-bottom: none;
   }
    td:nth-child(1){
    border-right:none;
     flex:1;
     text-indent: 40px;
     height: 40px;
     line-height: 40px;
    }
}
}

}
</style>
